var React = require('react');

function IconDashListLevel (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M62.487 51.966h101.448c4.447 0 8.065-3.618 8.065-8.065s-3.618-8.065-8.065-8.065H62.487c-4.447 0-8.065 3.618-8.065 8.065s3.618 8.065 8.065 8.065zM165.669 91.988H85.852c-3.467 0-6.331 3.618-6.331 8.065s2.864 8.065 6.331 8.065h79.817c3.467 0 6.331-3.618 6.331-8.065-.001-4.448-2.865-8.065-6.331-8.065zM167.402 148.214h-58.261c-2.563 0-4.597 3.618-4.597 8.065s2.11 8.065 4.597 8.065h58.185c2.563 0 4.597-3.618 4.597-8.065.001-4.448-2.034-8.065-4.521-8.065zM42.289 35.837H30.23c-.528 0-.98 3.618-.98 8.065s.452 8.065.98 8.065h12.059c.528 0 .98-3.618.98-8.065s-.453-8.065-.98-8.065zM67.461 91.988H55.403c-.528 0-.98 3.618-.98 8.065s.452 8.065.98 8.065h12.059c.528 0 .98-3.618.98-8.065s-.453-8.065-.981-8.065zM92.485 148.214h-12.06c-.528 0-.98 3.618-.98 8.065s.452 8.065.98 8.065h12.059c.528 0 .98-3.618.98-8.065s-.452-8.065-.979-8.065z"}));
}

IconDashListLevel.displayName = "IconDashListLevel";

IconDashListLevel.defaultProps = {"viewBox":"0 0 200 200"};

module.exports = IconDashListLevel;

IconDashListLevel.default = IconDashListLevel;
